<template>
  <div class="px-5 pb-4">
    <div class="footer-content">
      <div class="row">
        <div class="col-10 text-start booster-footer">
          <div class="item-body-small">
            <a
              href="https://www.booster.co.nz/products-services/insurance/booster-smartcover"
              target="_blank">
              <i class="bi bi-globe2 pe-1"></i> booster.co.nz
            </a>
          </div>
          <div class="item-body-small">
            <a href="mailto:adviserservices@booster.co.nz" target="_blank">
              <i class="bi bi-send pe-1"></i> {{ email }}@booster.co.nz
            </a>
          </div>
          <div class="item-body-small">
            <i class="bi bi-telephone pe-1"></i> 04 886 3206
          </div>
          <div class="item-body-small">
            <i class="bi bi-envelope pe-1"></i> PO Box 11872, Manners Street,
            Wellington
          </div>
          <div class="item-body-small footer-links">
            <a
              href="https://www.booster.co.nz/terms-and-conditions"
              target="_blank"
              ><i class="bi bi-file-earmark-text pe-1"></i>Terms and
              conditions</a
            >
            <a href="https://www.booster.co.nz/privacy-policy" target="_blank"
              >Privacy</a
            >
            <a
              href="https://www.booster.co.nz/why-booster/about-us"
              target="_blank"
              >About Booster</a
            >
          </div>
          <div v-if="canViewInvestments" class="item-body-small footer-links">
            <a
              href="https://www.surveymonkey.com/r/293SGHC"
              target="_blank"
              ><i class="bi bi-star pe-1"></i>Send feedback</a
            >
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-12 text-end footer-logo">
          <a href="https://www.booster.co.nz/" target="_blank">
            <img class="logo" alt="Booster" src="@/assets/booster-blue.svg" />
          </a>
          <div
            class="d-flex pt-4 align-items-center justify-content-end footer-social-icon">
            <a href="https://www.facebook.com/boosternz/" target="_blank">
              <img class="logo-icon me-1" src="@/assets/sm-facebook.png" />
            </a>
            <a href="https://www.linkedin.com/company/boosternz/" target="_blank">
              <img class="logo-icon me-1" src="@/assets/sm-linkedin.png" />
            </a>
            <a href="https://www.youtube.com/@BoosterNz" target="_blank">
              <img class="logo-icon" src="@/assets/sm-youtube.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRole } from '@/composables/useRole';
import { AppRoles } from '@/enums/ApplicationClaims.enum';

export default defineComponent({
    name: "BoosterFooter",
    data() {
        return {
          email: 'adviserservices',
          role: useRole()
        }
    },
    computed: {
      canViewInvestments(): boolean {
        return this.role.hasRole(AppRoles.InvestmentAdviser);
      }
    }
    // TODO will be used in future for other screens
    // watch: {
    //   $route(to) {
    //     this.email = to.path?.includes('insurance') ? 'insurance': 'adviserservices';
    //   }
    // }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/scss/booster-styles.scss';

.item-body-small {
    line-height: 1.25rem;
}

i {
    font-size: 0.625rem;
}

.logo-icon {
    width: 1.25rem;
    height: 1.25rem;
}

.booster-footer {
  a {
    text-decoration: none;
    color: $booster-text;
    &:hover {
      color: $booster-blue;
    }
  }
}

.footer-links {
  a {
    border-right: 1px solid $booster-medium-gray;
    padding: 0px 15px;
    color: $booster-text;
    text-decoration: underline;
    &:first-child {
      padding-left: 0px;
    }
    &:last-child {
      border-right: 0px;
    }
  }
}

.footer-content {
  border-top: 1px solid $booster-medium-gray;
  padding-top: 21px;
}
</style>
